import { FileType, TenantProfileGroup } from "../SalesAidModal";
import { ListItem } from "./ListItem";

export function List({ files = [], onDelete, fileUploadingProgress, isLoading, onChange, groupOptions = [] }: { onChange: (file: FileType) => void, files: FileType[], onDelete: (file: FileType) => void, fileUploadingProgress: {file: File, progress: string}[], isLoading: boolean, groupOptions: TenantProfileGroup[] }) {
    return (
        <div className="px-6 overflow-y-auto flex flex-col gap-2 my-2 max-h-[calc(100vh-500px)]">
            {files.map(file => (
                <ListItem key={file.id} file={file} onDelete={() => {
                    onDelete(file);
                }} 
                onChange={onChange}
                fileUploadingProgress={fileUploadingProgress.find(f => f.file.name === file.name)?.progress || "pending"}
                isLoading={isLoading}
                groupOptions={groupOptions}
                />
            ))}
        </div>
    )
}